import * as React from 'react';
import * as moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { getSelectedTeamAccount } from '../../../../../selectors/uiSelector';
import { Text, TextStyle, TextColor, Inset, InlineChildren, InsetSize, Icon, } from '@doordash/design-language';
import { CartCheckoutButton, CartCheckoutIconButton, JoinGroupCartButton, EntryContainer, EntryTileButtonsWrapper, CheckoutAvailableText, SpendingLimitText, DeleteCartButton, CheckoutInfoTooltip, } from './GroupOrderEntryStyles';
import { CalendarStrings } from '../Calendar/CalendarStrings';
import { EXTERNAL_ROUTES } from '../../../../../constants/values';
import { shouldUseMobileViewForEntryTile } from './EntryViewHelper';
import { useContainerDimensions } from '../../../../../utils/useContainerDimensions';
import { useCalendarViewContext } from '../Calendar/CalendarViewContext';
import StoreImageView from './StoreImageView';
import track from '../../../../../utils/track';
import { EmployeeCalendarEvents } from '../../../../../constants/events';
import { getTimeRangeFromTimeValue } from '../../../../StoreSelection/filters/utils';
import { DELIVERY_TIME_DISPLAY_FORMAT, DELIVERY_TIME_RANGE_INTERVAL, } from '../../../../StoreSelection/constants';
import { GroupOrderEntryTestId } from '../../../../../core/Common/testId';
import { checkEntrySize } from '../../utils/checkEntrySize';
var contentStrings = CalendarStrings.groupOrderEntry.checkoutAvailable;
var EntryViewCheckoutAvailable = function (_a) {
    var entry = _a.entry, showSpendingLimit = _a.showSpendingLimit, spendingLimitDescription = _a.spendingLimitDescription, _b = _a.debugMode, debugMode = _b === void 0 ? false : _b, onDeleteEntry = _a.onDeleteEntry;
    var entryRef = React.useRef(null);
    var dimensions = useContainerDimensions(entryRef);
    var isMobile = shouldUseMobileViewForEntryTile(dimensions);
    var teamAccountId = useSelector(getSelectedTeamAccount);
    var entryDate = moment(entry.checkoutTime).format('YYYY-MM-DD');
    var checkoutTimeFormatted = moment(entry.checkoutTime).format('h:mm A');
    var deliveryTimeFormatted = moment(entry.targetDeliveryTime).format('h:mm A');
    var deliveryTimeRangeDisplay = getTimeRangeFromTimeValue(deliveryTimeFormatted, DELIVERY_TIME_RANGE_INTERVAL, DELIVERY_TIME_DISPLAY_FORMAT);
    var _c = useCalendarViewContext(), isEmployeeView = _c.isEmployeeView, calendarInfo = _c.calendarInfo;
    var description = isEmployeeView
        ? contentStrings.employeeOrderBy()
        : contentStrings.adminCheckoutBy();
    // track the entry's size when it is mounted
    // to show the right size of CTA buttons when switching calendar views with showWeekends setting
    React.useEffect(function () {
        checkEntrySize(entryRef);
    }, []);
    var visitMarketplaceCheckout = function () {
        window.open(EXTERNAL_ROUTES.MARKETPLACE_CHECKOUT + "?order_cart_id=" + entry.cart.id, // link to checkout page
        '_blank', 'noopener');
    };
    var viewGroupCart = function () {
        track(EmployeeCalendarEvents.JOIN_GROUP_ORDER, {
            team_account_id: isEmployeeView
                ? calendarInfo === null || calendarInfo === void 0 ? void 0 : calendarInfo.teamAccountId
                : teamAccountId,
            cart_id: entry.cart.id,
            store_id: entry.store.id,
            date_clicked: entryDate,
        });
        window.open("" + entry.cart.link, // group cart short link
        '_blank', 'noopener');
    };
    // show minimized checkout button when the entry tile is resized
    var getCheckoutButton = function () {
        if (isMobile) {
            return React.createElement(CartCheckoutIconButton, { onClick: visitMarketplaceCheckout });
        }
        return (React.createElement(CartCheckoutButton, { "data-testid": GroupOrderEntryTestId.CartCheckoutButton, onClick: visitMarketplaceCheckout, children: React.createElement(Text, { styles: TextStyle.ButtonSmallTitle, color: TextColor.SystemWhite, overflow: Text.Overflows.Truncate }, contentStrings.checkoutButton()) }));
    };
    return (React.createElement(EntryContainer, { ref: entryRef },
        React.createElement(StoreImageView, { entry: entry },
            React.createElement(EntryTileButtonsWrapper, null,
                !isEmployeeView && (React.createElement(InlineChildren, { size: InlineChildren.Sizes.TagPaddingHorizontalMedium },
                    getCheckoutButton(),
                    React.createElement(DeleteCartButton, { "data-testid": GroupOrderEntryTestId.DeleteCartButton, onClick: function () { return onDeleteEntry(entry); } }))),
                isEmployeeView && (React.createElement(JoinGroupCartButton, { "data-testid": GroupOrderEntryTestId.JoinGroupCartButton, onClick: viewGroupCart, children: isMobile
                        ? contentStrings.joinGroupCartButtonMobileView()
                        : contentStrings.joinGroupCartButton() })))),
        React.createElement(Inset, { verticalSize: InsetSize.XSmall, horizontalSize: InsetSize.None },
            React.createElement(Text, { styles: TextStyle.Label2Emphasis }, entry.store.name),
            React.createElement(InlineChildren, { size: InlineChildren.Sizes.XxxSmall },
                React.createElement(CheckoutAvailableText, { children: description + " " + checkoutTimeFormatted }),
                React.createElement(CheckoutInfoTooltip, { content: contentStrings.infoTooltip(deliveryTimeRangeDisplay) }, function (_a) {
                    var describedBy = _a.describedBy;
                    return (React.createElement(Icon, { size: Icon.Sizes.Small, type: Icon.Types.InfoCircleLine, color: Icon.Colors.SystemGrey100, accessibilityLabel: describedBy }));
                })),
            React.createElement(SpendingLimitText, { visibility: showSpendingLimit, children: spendingLimitDescription })),
        debugMode && React.createElement(Text, null, entry.targetDeliveryTime)));
};
export default EntryViewCheckoutAvailable;
